export const CONFIGURED_SERVICES_TABS = {
  ACTIVE: 'Active',
  DEACTIVATED: 'Deactivated',
}

export const CONFIGURED_SERVICES_EXPANDED_TABS = {
  SERVICE_DETAILS: 'Service details',
  WORK_ORDERS: 'Work orders',
  ACTIVITY_HISTORY: 'Activity history',
  EDIT: 'Edit',
}

export const CONFIGURED_SERVICE_STATUS = {
  ACTIVE: 'Active',
  DEACTIVATED: 'Deactivated',
}
